import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Horses from "./pages/Horses";
import References from "./pages/References";
import Sponsors from "./pages/Sponsors";
import AboutUs from "./pages/AboutUs";
import GalleryPage from "./pages/GalleryPage";
import Contact from "./pages/Contact";
import { LanguageProvider } from "./components/LanguageContext";

// Helper component to handle page scroll to top on route change
function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
}

// Redirect component for old URLs (301-like client-side redirect)
function RedirectHandler() {
  const location = useLocation();
  const path = location.pathname;

  // Map old paths to new Danish paths
  if (path === "/" || path === "") {
    return <Navigate to="/da" replace />;
  }
  if (path === "/heste/salg") {
    return <Navigate to="/da/heste/salg" replace />;
  }
  if (path === "/heste/sportsheste") {
    return <Navigate to="/da/heste/sportsheste" replace />;
  }
  if (path === "/referencer") {
    return <Navigate to="/da/referencer" replace />;
  }
  if (path === "/sponsor") {
    return <Navigate to="/da/sponsorer" replace />;
  }
  if (path === "/om-os") {
    return <Navigate to="/da/om-os" replace />;
  }
  if (path === "/galleri") {
    return <Navigate to="/da/galleri" replace />;
  }
  if (path === "/kontakt") {
    return <Navigate to="/da/kontakt" replace />;
  }

  // Fallback: if it doesn't start with /da or /en, redirect to /da
  if (!path.startsWith("/da") && !path.startsWith("/en")) {
    return <Navigate to="/da" replace />;
  }

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <div className="relative flex min-h-screen flex-col bg-[#FCF9F5] text-stone-900 antialiased selection:bg-stone-200 selection:text-stone-900">
        {/* Ambient background glow */}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(90,75,65,0.03),transparent_50%)]" />

        <ScrollToTop />
        <Navbar />

        <main className="flex-grow">
          <Routes>
            {/* Redirects for old URLs and fallback */}
            <Route path="/" element={<RedirectHandler />} />
            <Route path="/heste/salg" element={<RedirectHandler />} />
            <Route path="/heste/sportsheste" element={<RedirectHandler />} />
            <Route path="/referencer" element={<RedirectHandler />} />
            <Route path="/sponsor" element={<RedirectHandler />} />
            <Route path="/om-os" element={<RedirectHandler />} />
            <Route path="/galleri" element={<RedirectHandler />} />
            <Route path="/kontakt" element={<RedirectHandler />} />

            {/* Danish Routes */}
            <Route path="/da" element={<Home />} />
            <Route path="/da/heste/sportsheste" element={<Horses />} />
            <Route path="/da/heste/salg" element={<Horses />} />
            <Route path="/da/referencer" element={<References />} />
            <Route path="/da/sponsorer" element={<Sponsors />} />
            <Route path="/da/om-os" element={<AboutUs />} />
            <Route path="/da/galleri" element={<GalleryPage />} />
            <Route path="/da/kontakt" element={<Contact />} />

            {/* English Routes */}
            <Route path="/en" element={<Home />} />
            <Route path="/en/horses/sport-horses" element={<Horses />} />
            <Route path="/en/horses/sales" element={<Horses />} />
            <Route path="/en/references" element={<References />} />
            <Route path="/en/sponsors" element={<Sponsors />} />
            <Route path="/en/about-us" element={<AboutUs />} />
            <Route path="/en/gallery" element={<GalleryPage />} />
            <Route path="/en/contact" element={<Contact />} />

            {/* Fallback redirect */}
            <Route path="*" element={<RedirectHandler />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
